import { Outlet, useLocation } from "react-router-dom";
import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import { ToastProvider } from "@/components/feature/ToastProvider";

export default function Layout() {
  const { pathname } = useLocation();
  const isHome = pathname === "/";

  return (
    <ToastProvider>
      <div className="flex min-h-screen flex-col bg-background-50">
        <Header />
        <main className={`flex-1 ${isHome ? "" : "pt-16"}`}>
          <Outlet />
        </main>
        <Footer />
      </div>
    </ToastProvider>
  );
}